module.exports = __webpack_public_path__ + "ath_game_web/img/7.9.74b5fbb4.png";